import '../polyfills';
import '../agentation_bootstrap';
import './application.scss';
import '../images/logo.png';
import '../images/puff.svg';

// Visitor tracking - tracks visits and page views
// turbo:load fires on initial page load AND after each Turbo navigation
import ahoy from 'ahoy.js';

// Paths to exclude from tracking (e.g., the analytics dashboard itself)
const excludedPaths = ['/admin/visitor_analytics'];

function shouldTrack() {
  return !excludedPaths.some((path) => window.location.pathname.startsWith(path));
}

// Track page views on initial load and Turbo navigations
document.addEventListener('turbo:load', () => {
  if (shouldTrack()) {
    ahoy.trackView();
  }
});

// Rails Template Inspector
// https://github.com/aki77/rails-template-inspector
// https://www.npmjs.com/package/@aki77/rails-template-inspector
if (import.meta.env.DEV) {
  import('@aki77/rails-template-inspector');
}

/* Remove media="screen" because otherwise when the stylesheet
      is copied to the iframe by react-to-print, it will be ignored
      because it's not a screen media type. */
document.addEventListener('DOMContentLoaded', () => {
  const linkTags = document.querySelectorAll('link[media="screen"]');
  linkTags.forEach((link) => link.removeAttribute('media'));
});
